module.exports = __webpack_public_path__ + "img/jh_success.9048942a.png";